import Head from 'next/head'
import { useRouter } from 'next/router'

import { useStaticData } from '@mc/static-data-react'

import { getUrlWithoutQueryParams } from 'libs/utils'
import { SITE_NAME, TWITTER_CARD, TWITTER_HANDLE } from 'libs/constants'

const Meta = () => {
  const { article } = useStaticData()
  const { asPath } = useRouter()
  const articleMeta = article.articleStructuredData[0]

  const getTitle = () => {
    const year = new Date().getFullYear()
    return `${articleMeta.name} - ${year} - ${SITE_NAME}`
  }

  const title = getTitle()
  const thumbnail = articleMeta.thumbnailUrl || articleMeta.image?.[0]

  return (
    <Head>
      <title>{title}</title>

      {articleMeta.keywords && (
        <meta content={articleMeta.keywords.join(', ')} name='keywords' />
      )}
      <meta content={articleMeta.description} name='description' />
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={articleMeta.name} property='og:caption' />
      <meta content={title} property='og:title' />
      <meta content={articleMeta.description} property='og:description' />
      {thumbnail && <meta content={thumbnail} name='og:image' />}
      <meta content={TWITTER_CARD} name='twitter:card' />
      <meta content={TWITTER_HANDLE} name='twitter:site' />
      <meta content={title} property='twitter:title' />
      <meta content={articleMeta.description} name='twitter:description' />
      {thumbnail && <meta content={thumbnail} name='twitter:image' />}
    </Head>
  )
}

export default Meta
